export const enUS = {
  minLength: "Minimum 8 characters",
  asciiOnly: "Only ASCII characters allowed",
  uppercaseRequired: "At least one uppercase letter (A-Z)",
  lowercaseRequired: "At least one lowercase letter (a-z)",
  numberOrSpecialRequired:
    "At least one number or special character (e.g. @, #, $, %, !)",
};
